import React, { } from 'react';
import { Grid2 as Grid, InputAdornment, MenuItem, TextField } from '@mui/material';
import { MdEditOff } from "react-icons/md";
import { stateOptions } from '../../Utils';

export const RemitterCardGrid = ({ handleFieldChange, state, updateRemitter, ts }) => {
    ""
    return (
        <Grid
            container
            rowSpacing={2}
            columnSpacing={1.5}
            columns={12}
            sx={{
                display: 'flex',
                flex: 1,
                width: 'auto',
                boxSizing: 'border-box',
                margin: 0,
                padding: 0,
                mt: '0vh'
            }}
        >
            <Grid item size={12}>
                <TextField
                    id="remitterName"
                    label="Remitter Name"
                    name="remitterName"
                    value={state.remitterName}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRemitter } }}
                    onChange={(e) => handleFieldChange('remitterName', e.target.value)}

                />
            </Grid>
            <Grid item size={6}>
                <TextField
                    id="remitterAddress1"
                    type={!updateRemitter ? "password" : 'default'}
                    label="Remitter Address 1"
                    name="remitterAddress1"
                    value={state.remitterAddress1}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRemitter } }}
                    onChange={(e) => handleFieldChange('remitterAddress1', e.target.value)}
                />
            </Grid >
            <Grid item size={4}>
                <TextField
                    id="remitterAddress2"
                    type={!updateRemitter ? "password" : 'default'}
                    label="Remitter Address 2"
                    name="remitterAddress2"
                    value={state.remitterAddress2}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRemitter } }}
                    onChange={(e) => handleFieldChange('remitterAddress2', e.target.value)}
                />
            </Grid >
            <Grid item size={4}>
                <TextField
                    id="remitterCity"
                    type={!updateRemitter ? "password" : 'default'}
                    label="Remitter City"
                    name="remitterCity"
                    value={state.remitterCity}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRemitter } }}
                    onChange={(e) => { handleFieldChange('remitterCity', e.target.value) }}
                />
            </Grid>
            <Grid item size={2}>
                <TextField
                    select
                    id="remitterState"
                    label="Remitter State"
                    name="remitterState"
                    value={state.remitterState}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRemitter } }}
                    SelectProps={{
                        MenuProps: {
                            PaperProps: {
                                style: {
                                    maxHeight: '20em',
                                },
                            },
                        },
                    }}
                    onChange={(e) => { handleFieldChange('remitterState', e.target.value) }}
                >
                    <MenuItem
                        value=''
                    >
                        N/A
                    </MenuItem>
                    {
                        stateOptions?.map(({ value, label, hidden }) => {
                            return <MenuItem key={label} value={value}>{!updateRemitter ? hidden : label}</MenuItem>
                        })
                    }
                </TextField>
            </Grid>
            <Grid item size={2}>
                <TextField
                    id="remitterZipCode"
                    type={!updateRemitter ? "password" : 'default' }
                    label="Remitter Zip Code"
                    name="remitterZipCode"
                    value={state.remitterZipCode}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRemitter } }}
                    onChange={(e) => { handleFieldChange('remitterZipCode', e.target.value.replace(/[^0-9]/g, '')) }}
                />
            </Grid>

        </Grid>
    )
}

export const RestitutionCardGrid = ({ handleFieldChange, state, updateRestitution, totalRestitutionRef, handleTotalRestitutionFocus, monthlyPaymentRef, handleMonthlyPaymentFocus, ts }) => {

    return (
        <Grid
            container
            rowSpacing={2}
            columnSpacing={1.5}
            columns={12}
            sx={{
                display: 'flex',
                flex: 1,
                width: 'auto',
                boxSizing: 'border-box',
                margin: 0,
                padding: 0,
                mt: '0vh'
            }}
        >
            <Grid item size={4}>
                <TextField
                    id="restitutionType"
                    label="Restitution Type"
                    name="restitutionType"
                    value={state.restitutionType}
                    sx={{ ...ts, width: '100%', backgroundColor: updateRestitution ? 'rgb(76, 78, 82)' : 'inherit' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRestitution } }}
                    onChange={(e) => { handleFieldChange('restitutionType', e.target.value.replace(/[^A-Za-z ]/g, '')) }}
                />
            </Grid>
            <Grid item size={4}>
                <TextField
                    id="startDate"
                    label="Restitution Start Date"
                    name="startDate"
                    value={state.startDate}
                    type="date"
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRestitution } }}
                    onChange={(e) => handleFieldChange('startDate', e.target.value)}

                />
            </Grid>
            <Grid item size={4}>
                <TextField
                    id="endDate"
                    label="Restitution End Date"
                    name="endDate"
                    value={state.endDate}
                    type="date"
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRestitution } }}
                    onChange={(e) => handleFieldChange('endDate', e.target.value)}

                />
            </Grid>
            <Grid item size={6}>
                <TextField
                    inputRef={totalRestitutionRef}
                    id="totalRestitutionAmount"
                    label="Total Restitution Amount"
                    name="totalRestitutionAmount"
                    value={state.totalRestitutionAmount}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: !updateRestitution } }}
                    onChange={(e) => handleFieldChange('totalRestitutionAmount', e.target.value.replace(/[^0-9.]/g, ''))}
                    onFocus={() => updateRestitution && handleTotalRestitutionFocus()}
                    onBlur={(e) => { updateRestitution && handleFieldChange('totalRestitutionAmount', new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(e.target.value.replace(/[^0-9.]/g, ''))) }}
                />
            </Grid>
            <Grid item size={4}>
                <TextField
                    id="totalPaid"
                    label="Amount Already Paid Towards Balance"
                    name="totalPaid"
                    value={state.totalPaid}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{
                        inputLabel: { shrink: true },
                        input: {
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <MdEditOff />
                                </InputAdornment>
                            )
                        }

                    }}
                    color={state?.totalPaid?.slice(1,) > 0.00 ? 'success' : 'warning'}
                    focused={state?.totalPaid?.slice(1,) === state?.totalRestitutionAmount?.slice(1,) || state.totalPaid?.slice(1,) === 0.00}
                />
            </Grid>
            <Grid item size={4}>
                <TextField
                    id="duration"
                    label="Duration"
                    name="duration"
                    value={state.duration}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: true, endAdornment: (<InputAdornment position="end" ><MdEditOff/></InputAdornment>) } }}
                    onChange={(e) => handleFieldChange('duration', e.target.value.replace(/[^0-9]/g, ''))}
                />
            </Grid>
            <Grid item size={4}>
                <TextField
                    inputRef={monthlyPaymentRef}
                    id="monthlyPaymentAmount"
                    label="Estimated Monthly Payment Amount"
                    name="monthlyPaymentAmount"
                    value={state.monthlyPaymentAmount}
                    sx={{ ...ts, width: '100%' }}
                    slotProps={{ inputLabel: { shrink: true }, input: { readOnly: true, endAdornment: (<InputAdornment position="end"><MdEditOff /></InputAdornment>) } }}
                    onChange={(e) => handleFieldChange('monthlyPaymentAmount', e.target.value.replace(/[^0-9.]/g, ''))}
                    onFocus={() => updateRestitution && handleMonthlyPaymentFocus()}
                    onBlur={(e) => { handleFieldChange('monthlyPaymentAmount', new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(e.target.value.replace(/[^0-9.]/g, ''))) }}
                />
            </Grid>
        </Grid>
    )
}